import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloud = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18 19C20.7614 19 23 16.7614 23 14C23 11.485 21.1431 9.40363 18.7254 9.05224C17.875 6.10562 15.1586 4 12 4C9.65343 4 7.50902 5.16507 6.21989 7.05027C3.26703 7.43346 1 9.95877 1 13C1 16.3137 3.68629 19 7 19H18ZM21 14C21 15.6569 19.6569 17 18 17H7C4.79086 17 3 15.2091 3 13C3 10.8504 4.69934 9.08715 6.83965 9.00314L7.39066 8.98151L7.66642 8.50398C8.5543 6.96643 10.1924 6 12 6C14.4511 6 16.5303 7.77626 16.9309 10.1662L17.0738 11.0182L17.9375 11.0006C17.9531 11.0004 17.9608 11.0002 17.9686 11.0002C17.9765 11.0001 17.9843 11.0001 18 11C19.6569 11 21 12.3431 21 14Z",
		fill: "#256F94"
	})
});
export default SvgCloud;
